module.exports = __webpack_public_path__ + "static/img/nan.36aef538.png";